import * as ActionType from '../../core/ActionType';
import InitialState from '../../core/InitialState';
import _ from 'lodash';


const agricultorReducer = (state = InitialState.agricultorReducer, action) => {
    switch(action.type) {
        case ActionType.GET_AGRICULTORES_RESPONSE || ActionType.ADD_AGRICULTOR_RESPONSE: {
            return {
                ...state, 
                agricultorObject: _.assign(action.agricultorObject),
                error: _.assign(action.error)
            };
        }


        default: { return state; }
    }
};

export default agricultorReducer;